export enum IntegratedApp {
  SHOPIFY = 'shopify',
  STUDIO_SHOPIFY = 'shopifyStudio',
  INSTAGRAM = 'instagramGraph',
  TIKTOK = 'tiktok',
  GOOGLE_DRIVE = 'googleDrive',
  DROPBOX = 'dropbox',
  PRODUCT = 'product',
  UPLOADED = 'uploaded',
  AI_GENERATED = 'aiGenerated',
}
